import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DefaultStateService } from '@formbird/services';

/**
 * Generic standalone error page. Displays the `errorMessage` query parameter on a
 * centered layout styled like the not-found page. It is the redirect target for
 * server-side failures such as authentication (e.g. Keycloak) errors.
 *
 * @example
 * /error?errorMessage=Failed%20to%20obtain%20access%20token
 */
@Component({
  selector: 'ft-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.Emulated,
  imports: [MatButtonModule, MatIconModule]
})
export class ErrorPageComponent {
  private defaultStateService = inject(DefaultStateService);

  /** Page heading. */
  readonly title = 'Something went wrong';

  /** The error message read from the `errorMessage` query parameter. */
  readonly message: string;

  constructor() {
    const parameters = new URLSearchParams(window.location.search);
    this.message = parameters.get('errorMessage') || 'An unexpected error occurred.';
  }

  /** Navigate back to the application's default state. */
  changeState() {
    this.defaultStateService.changeToDefaultState();
  }
}
